export const REPLY_TEMPLATES = [
  {
    id: "activation", label: "Activation steps",
    text: `Here's how to activate your plugin:

1. In DaVinci Resolve, add the KolorKlinic plugin to a clip and open its panel. Copy the Machine ID shown there (format XXXX-XXXX-XXXX).
2. Go to the Activate page on our website, enter your licence key and that Machine ID, then click "Get activation code".
3. Paste the activation code into the Activation code field in the plugin panel. The watermark disappears and the plugin then works fully offline.

Each key works on up to 3 machines. If anything still doesn't work, send me a screenshot of the plugin panel and I'll take a look.`,
  },
  {
    id: "lost-key", label: "Lost key",
    text: `No problem. You can get your key again in a few seconds: open the Activate page on our website, scroll to "Lost your key?" and enter the email you used at checkout. Every key bought with that email is sent to you straight away (check your spam folder too).

If you used a different email at checkout or nothing arrives, reply with your order date and the email on the payment, and I'll find it for you.`,
  },
  {
    id: "changed-computer", label: "Changed computer",
    text: `Each licence works on up to 3 machines. To move it to your new computer:

1. Open the Activate page on our website and go to "Changed computer?".
2. Enter your licence key, click "Show machines" and remove the machine you no longer use.
3. Activate the new computer as usual with its Machine ID.

You can free up to 3 slots every 12 months. If you've used them all, just reply here and I'll free one for you.`,
  },
  {
    id: "billing", label: "Refund / billing",
    text: `Thanks for getting in touch about your order. I've looked into it and will sort it out for you.

If you'd like a refund, just confirm here and I'll process it through Stripe. It usually shows up on your statement within 5–10 business days. Your invoice is also in the receipt email Stripe sent you after checkout.`,
  },
  {
    id: "bug", label: "Bug report",
    text: `Thanks for reporting this, and sorry for the trouble. To reproduce it on my side, could you send me:

- your DaVinci Resolve version (Help > About) and whether it's the free or Studio version
- your operating system and GPU (e.g. macOS 14 on M2 Max, or Windows 11 with an RTX 4080)
- the plugin version and the settings you used (a screenshot of the panel is perfect)
- if possible, a short description of the clip (resolution, codec, colour space)

I'll get back to you as soon as I've looked into it.`,
  },
];
